import { render, staticRenderFns } from "./bk-bets-list.vue?vue&type=template&id=2b417319"
import script from "./bk-bets-list.vue?vue&type=script&lang=js"
export * from "./bk-bets-list.vue?vue&type=script&lang=js"
import style0 from "./bk-bets-list.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/bk-bets-list.vue
// module id = o+rO
// module chunks = 0